import React from 'react';
import { spaces, colors } from '../../lib/styles';
import styled from 'styled-components';

interface Props {
    progress: number;
}

const Progress = styled.div`
    background-color: ${colors.heritage};
    width: inherit;
    height: inherit;
`;

const StyledProgressBar = styled.div`
    position: relative;
    background-color: ${colors.grey100};
    width: 100%;
    height: ${spaces.space4}px;
    overflow: hidden;
    z-index: 1;
`;

export const ProgressBar = ({ progress }: Props) => (
    <StyledProgressBar>
        <Progress style={{ width: progress + '%' }}></Progress>
    </StyledProgressBar>
);

export default ProgressBar;
